<script lang="ts" setup>
import ProductColorGroupSelector from '#components/product-color-group-selector/ProductColorGroupSelector.vue'
import { ref } from 'vue'
import type { HomepageFeaturedCollectionProps } from '.'

// TODO: Use type `HomepageFeaturedCollectionProps` instead of re-defining the props
// after Vue fix their issue: https://github.com/vuejs/core/issues/8482
const { title, products, section } = defineProps<{
  title: HomepageFeaturedCollectionProps['title']
  products: HomepageFeaturedCollectionProps['products']
  section: HomepageFeaturedCollectionProps['section']
}>()

type Product = NonNullable<(typeof products)[0]>

// Product selection stuff
const currentProduct = ref(products[0])

const selectProduct = (payload: { product: Partial<Product> }) => {
  const matchedProduct = products.find((p) => p.id === payload.product.id)

  if (!matchedProduct) return

  currentProduct.value = matchedProduct
}

// Add to cart stuff
const actionUrl = `${window.Shopify.routes.root}/cart/add`
</script>

<template>
  <div
    class="homepage-featured-collection__image tw-full tw-aspect-[309/343] tw-min-h-[343px] lg:tw-aspect-[666/740] lg:tw-min-h-[740px] lg:tw-min-w-[49%] lg:tw-max-w-[49%]"
    v-html="currentProduct?.imageHtml"
  ></div>

  <div class="homepage-featured-collection__main tw-flex-1 lg:tw-py-[88px]">
    <div class="tw-flex tw-flex-col tw-gap-[30px]">
      <h2 class="label">{{ title }}</h2>
      <h3 class="h2">{{ currentProduct?.title }}</h3>
      <p class="p1 tw-font-bold">{{ currentProduct?.price }}</p>
      <p class="p1" v-html="currentProduct?.excerpt"></p>
    </div>

    <ProductColorGroupSelector
      :products="products"
      :redirect-on-select="false"
      class="tw-mb-[20px] tw-mt-[60px] lg:tw-mb-[16px]"
      @select="selectProduct"
    />

    <div class="tw-flex tw-w-full tw-flex-col tw-gap-[20px] lg:tw-gap-[16px]">
      <!-- Cloned from Dawn theme native product form -->
      <product-form class="product-form">
        <div class="product-form__error-message-wrapper" role="alert" hidden="">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
            <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
            <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
            <path
              d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z"
              fill="white"
            ></path>
            <path
              d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z"
              fill="white"
              stroke="#EB001B"
              stroke-width="0.7"
            ></path>
          </svg>
          <span class="product-form__error-message"></span>
        </div>

        <form
          id="product-form-template--23845287887230__main"
          method="post"
          :action="actionUrl"
          accept-charset="UTF-8"
          class="form"
          enctype="multipart/form-data"
          novalidate="true"
          data-type="add-to-cart-form"
        >
          <input type="hidden" name="form_type" value="product" />
          <input type="hidden" name="utf8" value="✓" />
          <input type="hidden" name="id" :value="currentProduct?.variantId" />

          <div class="product-form__buttons">
            <button
              type="submit"
              name="add"
              class="product-form__submit button button--full-width button--black p2 tw-uppercase tw-text-white"
            >
              <span>Add to Cart</span>

              <div class="loading-overlay__spinner hidden">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  role="presentation"
                  class="spinner"
                  viewBox="0 0 66 66"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
            </button>
          </div>

          <input type="hidden" name="product-id" :value="currentProduct?.id" />
          <input type="hidden" name="section-id" :value="section.id" />
        </form>
      </product-form>

      <a :href="currentProduct?.url" class="p2 button button--outline tw-uppercase">Product Details</a>
    </div>
  </div>
</template>
